import { ElementRef, useRef } from "react";
import LinkComponent from "@Components/Link";
import Image from "components/Image";
import { HorizontalScrollContainer } from "./HorizontalScrollContainer";
import classes from "./ShopByContainer.module.scss";

interface IShopByContainerProps {
  shopByLinks?: any;
}

const ShopByContainer = ({ shopByLinks = [] }: IShopByContainerProps) => {
  const containerRef = useRef<ElementRef<"ul">>(null);
  if (!shopByLinks?.length) return null;

  return (
    <div className={classes["shop-by-container"]}>
      <div className={classes["shop-by-container__box"]}>
        <HorizontalScrollContainer containerRef={containerRef}>
          <ul
            className={classes["shop-by-container__links"]}
            ref={containerRef}
          >
            {shopByLinks?.map((link: any) => (
              <ShopByLink
                key={link.title}
                title={link?.title}
                link={link.link}
                icon={link.icon}
              />
            ))}
          </ul>
        </HorizontalScrollContainer>
      </div>
    </div>
  );
};

const ShopByLink = ({ title, link, icon }: any) => {
  return (
    <LinkComponent href={link} key={title}>
      <a className={classes["shop-by-container__alink"]}>
        <span className={classes["shop-by-container__icon"]}>
          <Image src={icon?.url} width={35} height={35} alt="Logo" />
        </span>
        <span className={classes["shop-by-container__label"]}>{title}</span>
      </a>
    </LinkComponent>
  );
};

export default ShopByContainer;
